import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { ProgressCard as ProgressCardType } from './types';
import { DefaultProgressCardItem } from './ProgressCardItem';

const CardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : (theme.palette.background.card || theme.palette.grey[50]),
  borderRadius: 'calc(4px + 0.625rem)',
  padding: theme.spacing(3),
  boxShadow: theme.palette.mode === 'dark' ? '0px 2px 4px rgba(0, 0, 0, 0.3)' : '0px 2px 4px rgba(0, 0, 0, 0.1)',
  border: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(2),
  '&:last-child': {
    marginBottom: 0,
  },
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: theme.spacing(3),
  lineHeight: 1.3,
}));

const ItemsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

interface DefaultProgressCardProps {
  card: ProgressCardType;
}

export const DefaultProgressCard: React.FC<DefaultProgressCardProps> = ({ card }) => {
  const { title, items, variant = 'default' } = card;

  if (!title && (!items || items.length === 0)) {
    return null;
  }

  return (
    <CardContainer>
      {title && (
        <TitleText>
          {title}
        </TitleText>
      )}
      
      {items && items.length > 0 && (
        <ItemsContainer>
          {items
            .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
            .map((item, index) => (
              <DefaultProgressCardItem 
                key={index} 
                item={item} 
              />
            ))}
        </ItemsContainer>
      )}
    </CardContainer>
  );
};